import ChatBotInput from "./ChatBotInput";
import '../styles/chatbot-input.css';
import '../styles/chatbot-chat.css';
import FujitsuIcon from "../assets/icons/fujitsu_icon.svg";
import {useContext, useEffect, useRef, useState} from "react";
import {HomeContext} from "../context/HomeContext";
import {useParams} from "react-router-dom";
import {getChatHistory, sendQuery} from "../services/ChatBotService";
import {ChatBotContext} from "../context/ChatBotContext";
import {useRive, useStateMachineInput} from "@rive-app/react-canvas";
import CustomTTSComponent from "./CustomTTS";


const ChatBotChat = () => {

    /* RIVE */
    const STATE_MACHINE = "avatar2"

    const { rive, RiveComponent } = useRive({
        src: "/avatar_fujitsu_sustainability.riv",
        stateMachines: STATE_MACHINE,
        autoplay: true,
    });

    const isTalkingInput = useStateMachineInput(
        rive,
        STATE_MACHINE,
        "isTalking"
    );

    const {query, newChat, setChats} = useContext(HomeContext)

     /* HOOKS */
    const { chat_id } = useParams();

    const selectedChatRef = useRef(chat_id);

    const [messages, setMessages] = useState([]);

    const endOfMessagesRef = useRef(null);

    /* USE EFFECTS */
    useRef(chat_id);
    const setChatsRef = useRef(setChats);
    const newChatRef = useRef(newChat);
    useEffect(() => {
        // TODO CUANDO LA QUERY ES LA MISMA NO SE VA A EJECUTAR
        if (!query) return;
        setMessages((prevMessages) => [
            ...prevMessages,
            { content: query, role: "human" },
            { role: "ai", content: "", loading: true }
        ]);
        sendQuery(query, selectedChatRef.current, "prueba@gmail.com").then((result) => {
            setMessages((prevMessages) => {
                const updatedMessages = [...prevMessages];
                updatedMessages.pop();
                updatedMessages.push(result);
                return updatedMessages;
            });
            if (newChatRef.current){
                setChatsRef.current((prev) => [...prev, {"title": query}])
            }
            
        });
    }, [query]);

    useEffect(() => {
        if (!newChat) {
            getChatHistory(chat_id)
                .then((result) => setMessages(result.data))
                .catch((error) => console.error("Error cargando mensajes:", error));
        }
    }, [chat_id, newChat]);

    useEffect(() => {
        endOfMessagesRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);


    
    return (
        <div className="chatbot-container">
            <div className="chatbot-container-content">
                <div className={"chatbot-chat"}>
                    <div className="messages">
                        {
                            messages ? messages.map((item, index) => {
                                return (
                                    <div className="message" key={index}>
                                        {
                                            item["role"] === "human" ?
                                                <div className="user-message">
                                                    <p>{item["content"]}</p>
                                                </div>
                                                :
                                                <div className="ai-message">
                                                    <div className="icon">
                                                        <img src={FujitsuIcon} alt=""/>
                                                    </div>
                                                    {item.loading ? (
                                                        <div className="loading-spinner"></div>
                                                    ) : (
                                                        <CustomTTSComponent highlight isTalkingInput={isTalkingInput} >
                                                            <p>{item["content"]}</p>
                                                        </CustomTTSComponent>
                                                    )}
                                                </div>
                                        }
                                    </div>
                                )
                            }) : <p>Nothing here</p>
                        }
                        <div ref={endOfMessagesRef}/>
                    </div>
                    <ChatBotContext.Provider value={{setMessages}}>
                        <ChatBotInput/>
                    </ChatBotContext.Provider>
                    <div className={"avatar"}>
                        <RiveComponent/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChatBotChat;